import { getMgLocalStorage } from '@utils';
import { MgLocalStorageKeys } from '@enums';

const token = getMgLocalStorage<string>(MgLocalStorageKeys.TOKEN);

export type AuthState = {
  isLoginLoading: boolean;
  isLoggedIn: boolean;
  isLoginFailure: boolean;
  token: string;
};

export const authInitialState: AuthState = {
  isLoginLoading: false,
  isLoggedIn: false,
  isLoginFailure: false,
  token,
};
